var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":"drawing_canvas"}}),_c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"audio-effect",attrs:{"src":_vm.audioSrc,"controls":"","preload":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }